import './TransferBankSteps.css'
import StepsItem from '../StepsItem/StepsItem';
import TransferBankSendOptions from '../TransferBankSendOptions/TransferBankSendOptions';
import {IconNumber1, IconNumber2, IconNumber3} from '@tabler/icons-react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

export default function TransferBankSteps({transferBankSteps, transferBankSendOptionsTxt, TransferBankConfirmModalTxt}) {
    const {width} = useWindowDimensions()
    const isMediumDimension = width <= 1200;
    const {title, stepOne, stepTwo, stepThree} = transferBankSteps;

    return (
        <div className='transfer-bank-steps-container'>
            <div className='transfer-bank-follow-steps-container'>

                <h4 className='transfer-bank-follow-steps-headline'>{title}</h4>

                <div className='transfer-bank-steps-items-container'>
                    <StepsItem StepsItem
                               icon={< IconNumber1 width={30} height={30} stroke-width={2}
                                                   className='transfer-bank-steps-item--icon'
                                                   color='var(--color-white)'/>}
                               text={stepOne}
                    />

                    < StepsItem
                        icon={< IconNumber2 width={30} height={30} stroke-width={2}
                                            className='transfer-bank-steps-item--icon' color='var(--color-white)'/>}
                        text={stepTwo}
                    />

                    < StepsItem
                        icon={< IconNumber3 width={30} height={30} stroke-width={2}
                                            className='transfer-bank-steps-item--icon' color='var(--color-white)'/>}
                        text={stepThree}
                    />

                    {!isMediumDimension && < TransferBankSendOptions transferBankSendOptionsTxt={transferBankSendOptionsTxt} TransferBankConfirmModalTxt={TransferBankConfirmModalTxt}/>}

                </div>

            </div>
        </div>
    )
}
